import { render, staticRenderFns } from "./Histories.vue?vue&type=template&id=99643dca&scoped=true"
import script from "./Histories.vue?vue&type=script&lang=js"
export * from "./Histories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99643dca",
  null
  
)

export default component.exports